import { render } from "./AnsprechpartnerEditButtonModal.pug?vue&type=template&id=407b7a48&lang=pug"
import script from "./AnsprechpartnerEditButtonModal.js?vue&type=script&lang=js"
export * from "./AnsprechpartnerEditButtonModal.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__